import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import * as Common from 'common/components';

class DisabledReportTable extends PureComponent {
  static propTypes = {
    children: PropTypes.any,
    count: PropTypes.number.isRequired,
    handleOrderChange: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
    company: PropTypes.any,
    subcompany: PropTypes.any,
    permissions: PropTypes.any,
  };

  render = () => {
    const { t, company, subcompany, permissions, children } = this.props;
    const headers = [
      {
        variable: 'number',
        text: t('assets.fields.number') + ': ',
        type: 'h3',
      },
      { variable: 'name', text: t('assets.fields.name') + ': ' },
      {
        parent: '_costCenter',
        variable: 'key',
        text: t('assets.fields.costCenter') + ' Llave: ',
      },
      {
        parent: '_costCenter',
        variable: 'name',
        text: t('assets.fields.costCenter') + ' Nombre: ',
      },
      {
        parent: '_account',
        variable: 'name',
        text: t('assets.fields.account') + ': ',
      },
      {
        parent: '_subaccount',
        variable: 'name',
        text: t('assets.fields.subaccount') + ': ',
      },
      {
        variable: 'disableDetail',
        text: t('assets.fields.disableDetail') + ': ',
      },
      { variable: 'buyDate', text: t('assets.fields.buyDate') + ': ' },
      {
        variable: 'name',
        isDepreciation: true,
        text: t('assets.fields.depreciationName') + ': ',
      },
      { variable: 'startDate', text: t('assets.fields.startDate') + ': ' },
      {
        variable: 'disableDate',
        text: t('assets.fields.disableDate') + ': ',
      },
      {
        variable: 'price',
        number: true,
        text: t('assets.fields.price') + ': ',
      },
      {
        variable: 'years',
        isDepreciation: true,
        number: true,
        presicion: 4,
        text: t('assets.fields.life') + ': ',
      },
      {
        variable: 'originalAmount',
        isDepreciation: true,
        number: true,
        presicion: 4,
        text: t('assets.fields.moi') + ': ',
      },
      {
        parent: 'factors',
        variable: 'inpcBegin',
        isDepreciation: true,
        number: true,
        presicion: 4,
        text: t('assets.fields.inpcStart') + ': ',
      },
      {
        parent: 'factors',
        variable: 'inpcEnd',
        isDepreciation: true,
        number: true,
        presicion: 4,
        text: t('assets.fields.inpcEnd') + ': ',
      },
      {
        parent: 'factors',
        variable: 'factor',
        isDepreciation: true,
        number: true,
        presicion: 4,
        text: t('assets.fields.factor') + ': ',
      },
      {
        variable: 'totalDepreciation',
        isDepreciation: true,
        number: true,
        text: t('assets.fields.totalDepreciation') + ': ',
      },
      {
        variable: 'depreciable',
        isDepreciation: true,
        number: true,
        text: t('assets.fields.depreciable') + ': ',
      },
      {
        variable: 'disableAmount',
        number: true,
        text: t('assets.fields.disableAmount') + ': ',
      },
      {
        variable: 'refound',
        isDepreciation: true,
        number: true,
        text: t('assets.fields.refound') + ': ',
      },
    ];

    const config = {
      noActions: true,
      actions: t('common.actions'), //Texto de seccion de acciones
      edit: t('common.edit'), //Texto de boton editar
      editPermission: 'acl.assets.update.NoTiene',
      togglePermission: 'acl.assets.toggle.NoTiene',
      editUrl: 'assets', //Url para editar empleado
      propsName: 'asset', //de donde se obtienen los props
      company: company,
      subcompany: subcompany,
    };

    const dataCard = {
      rows: children,
      headers: headers,
      config: config,
      permissions: permissions,
    };
    return (
      <Common.List dataCard={dataCard}>
        <thead>
          <tr>
            <Common.ThSortable
              orderBy={this.props.orderBy}
              order={this.props.order}
              field="number"
              handleOrderChange={this.props.handleOrderChange}
            >
              {this.props.t('assets.fields.number')}
            </Common.ThSortable>

            <Common.ThSortable
              orderBy={this.props.orderBy}
              order={this.props.order}
              field="name"
              handleOrderChange={this.props.handleOrderChange}
            >
              {this.props.t('assets.fields.name')}
            </Common.ThSortable>

            <Common.ThSortable
              orderBy={this.props.orderBy}
              order={this.props.order}
              field="_costCenter.name"
              handleOrderChange={this.props.handleOrderChange}
            >
              {this.props.t('assets.fields.costCenter')}
            </Common.ThSortable>

            <Common.ThSortable
              orderBy={this.props.orderBy}
              order={this.props.order}
              field="_account.name"
              handleOrderChange={this.props.handleOrderChange}
            >
              {this.props.t('assets.fields.account')}
            </Common.ThSortable>

            <Common.ThSortable
              orderBy={this.props.orderBy}
              order={this.props.order}
              field="_subaccount.name"
              handleOrderChange={this.props.handleOrderChange}
            >
              {this.props.t('assets.fields.subaccount')}
            </Common.ThSortable>

            <th>{this.props.t('assets.fields.disableDetail')}</th>

            <Common.ThSortable
              orderBy={this.props.orderBy}
              order={this.props.order}
              field="buyDate"
              handleOrderChange={this.props.handleOrderChange}
            >
              {this.props.t('assets.fields.buyDate')}
            </Common.ThSortable>

            <th>{this.props.t('assets.fields.depreciationName')}</th>
            <Common.ThSortable
              orderBy={this.props.orderBy}
              order={this.props.order}
              field="startDate"
              handleOrderChange={this.props.handleOrderChange}
            >
              {this.props.t('assets.fields.startDate')}
            </Common.ThSortable>

            <Common.ThSortable
              orderBy={this.props.orderBy}
              order={this.props.order}
              field="disableDate"
              handleOrderChange={this.props.handleOrderChange}
            >
              {this.props.t('assets.fields.disableDate')}
            </Common.ThSortable>
            <th>{this.props.t('assets.fields.price')}</th>
            <th>{this.props.t('assets.fields.life')}</th>
            <th>{this.props.t('assets.fields.moi')}</th>
            <th>{this.props.t('assets.fields.inpcStart')}</th>
            <th>{this.props.t('assets.fields.inpcEnd')}</th>
            <th>{this.props.t('assets.fields.factor')}</th>
            <th>{this.props.t('assets.fields.totalDepreciation')}</th>
            <th>{this.props.t('assets.fields.depreciable')}</th>
            <th>{this.props.t('assets.fields.disableAmount')}</th>
            <th>{this.props.t('assets.fields.refound')}</th>
          </tr>
        </thead>

        <tbody>
          {this.props.count === 0 && <Common.EmptyTable colSpan={20} />}
          {this.props.children}
        </tbody>
      </Common.List>
    );
  };
}

export default translate()(DisabledReportTable);



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/components/disabled/DisabledReportTable.js